import React from 'react'
import IrregularInteraction from '../IrregularInteraction'
import ItemImage from '../ItemImage'
import image from '../../assets/images/item--sofa-2@3x.png'

const path =
  'M103.008787,167.046281 L83.31,178.08 C83.31,178.08 7.29,134.43 2.51,131.5 C3.06850884,115.028584 2.22883217,98.5394755 0,82.21 L19.71,71.17 L82.65,107.206946 L82.65,89.02 L236.52,0 L260.82,13.62 L260.82,80.24 L106.96,169.26 L103.008787,167.046281 Z'

const Sofa2 = props => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 257 144"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Sofa2.propTypes = IrregularInteraction.propTypes

export default Sofa2



// WEBPACK FOOTER //
// ./src/components/items/Sofa2.js